import React from 'react';

import Alert from '@amzn/meridian/alert';
import Link from '@amzn/meridian/link';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';

const T2PlusBanner = () => {
  return (
    <Row spacingInset={'none none 400 none'} width={'fill'} alignmentHorizontal="center">
      <Alert type="theme" aria-label="T2+ Alert" width={'80%'}>
        <Text>
          Questions on Return to Work's T2+ experience? Please visit our Wiki&nbsp;
          <Link href="https://w.amazon.com/bin/view/Whs/gmh/health-solutions/rtw/faq/">FAQ</Link>
          &nbsp;page.
        </Text>
      </Alert>
    </Row>
  );
};

export default T2PlusBanner;
